export const daData = {
  title: "Privatlivs- og Cookiepolitik – Danghuan",
  sections: [
    {
      title: "Introduktion",
      content: `
        <p>Denne privatlivs- og cookiepolitik forklarer, hvordan Danghuan Europe S.L. ('vi', 'os' eller 'Danghuan') indsamler, anvender og beskytter dine personoplysninger, når du interagerer med vores websites og tjenester. Denne politik gælder for beboere i Det Europæiske Økonomiske Samarbejdsområde (EØS) og Storbritannien (UK) og overholder den generelle databeskyttelsesforordning (GDPR), den britiske databeskyttelsesforordning (UK GDPR) samt den danske databeskyttelseslov (Databeskyttelsesloven).</p>
      `
    },
    {
      title: "Omfanget af denne politik",
      content: `
        <p>Denne politik gælder for:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Besøgende på vores hjemmeside (https://www.danghuan.eu)</li>
          <li style='margin-bottom: 8px;'>Kunder og potentielle kunder</li>
          <li style='margin-bottom: 8px;'>Brugere af vores bytte- og videresalgstjenester</li>
          <li style='margin-bottom: 8px;'>Repræsentanter for forretningspartnere og tilknyttede platforme</li>
        </ul>
      `
    },
    {
      title: "Hvilke data vi indsamler",
      content: `
        <p>Afhængigt af din interaktion med os kan vi indsamle:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Fulde navn, adresse, e-mail og telefonnummer</li>
          <li style='margin-bottom: 8px;'>IBAN, sorteringskode og kontonummer, PayPal, Revolut eller andre bankoplysninger</li>
          <li style='margin-bottom: 8px;'>Enhedsoplysninger (model, mærke, tilstand, prisinformation, IMEI)</li>
          <li style='margin-bottom: 8px;'>Kommunikationshistorik med kundeservice</li>
          <li style='margin-bottom: 8px;'>Markedsføringspræferencer og kampagneinteraktioner</li>
          <li style='margin-bottom: 8px;'>IP-adresse, browsertype, sessions-ID og placering</li>
          <li style='margin-bottom: 8px;'>Platformdata fra Shopify, Amazon, TEMU, Back Market</li>
        </ul>
        <p>Vi kan modtage visse oplysninger om dig fra vores platforme eller logistikpartnere (f.eks. Shopify, Amazon, Back Market, TEMU), når du interagerer med deres platforme i forbindelse med vores tjenester. Dette omfatter ordredata, leveringsadresse og transaktionsstatus.</p>
      `
    },
    {
      title: "Brugen af personoplysninger",
      content: `
        <p>Vi bruger dine personoplysninger til at:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Behandle og fuldføre dine bytte-, salgs- eller serviceanmodninger</li>
          <li style='margin-bottom: 8px;'>Kontakte dig vedrørende ordrestatus, forsendelsesoplysninger eller supportforespørgsler</li>
          <li style='margin-bottom: 8px;'>Forbedre vores kundeservice, driftseffektivitet og brugeroplevelse</li>
          <li style='margin-bottom: 8px;'>Opfylde juridiske og regulatoriske forpligtelser, herunder regnskab, skat og rapporteringskrav</li>
          <li style='margin-bottom: 8px;'>Analysere og overvåge brugen af vores tjenester for at forhindre svig eller misbrug</li>
          <li style='margin-bottom: 8px;'>Kommunikere med dig om kampagner, serviceopdateringer eller ændringer i vilkår, hvor dette er relevant og lovligt</li>
        </ul>
      `
    },
    {
      title: "Cookies",
      content: `
        <p>Vi bruger cookies til at forbedre din browseroplevelse og optimere vores tjenester. Cookies kan indsamle:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>IP-adresse og geolokation</li>
          <li style='margin-bottom: 8px;'>Browser-/enhedsidentifikatorer</li>
          <li style='margin-bottom: 8px;'>Brugsadfærd (besøgte sider, tid på siden, klik)</li>
        </ul>
        <p>Typer af cookies:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Strengt nødvendige cookies</li>
          <li style='margin-bottom: 8px;'>Funktionelle cookies</li>
          <li style='margin-bottom: 8px;'>Ydelsescookies</li>
          <li style='margin-bottom: 8px;'>Annonceringscookies</li>
        </ul>
        <p>Du kan til enhver tid konfigurere eller tilbagekalde cookieindstillinger via din browser eller cookie-banneret.</p>
      `
    },
    {
      title: "Tredjeparter, som vi deler data med",
      content: `
        <p>Vi deler data med betalingspartnere og logistikpartnere baseret på kontraktmæssig nødvendighed og med analyseudbydere baseret på dit cookie-samtykke.</p>
        <p>Vi kan dele dine data med:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Betalingspartnere: PayPal, Revolut, VISA, Mastercard, Stripe</li>
          <li style='margin-bottom: 8px;'>Logistikpartnere: UPS, Correos, DPD, Royal Mail, NACEX, FedEx</li>
          <li style='margin-bottom: 8px;'>Platformpartnere: Shopify, Amazon, TEMU, BackMarket</li>
          <li style='margin-bottom: 8px;'>Marketing- og analyseudbydere: Google, Meta, TikTok, REDnote, X (Twitter), Instagram, LinkedIn</li>
          <li style='margin-bottom: 8px;'>IT-udbydere, konsulenter, juridiske rådgivere</li>
          <li style='margin-bottom: 8px;'>Offentlige myndigheder, hvis det kræves ved lov</li>
        </ul>
        <p>Data kan overføres uden for EØS/UK under EU-godkendte sikkerhedsforanstaltninger såsom standardkontraktbestemmelser.</p>
      `
    },
    {
      title: "Brug af tredjeparts varemærkelogoer",
      content: `
        <p>Vores hjemmeside viser mærkenavne og logoer som Apple, Samsung, OPPO, OnePlus, VIVO, Xiaomi, Google og andre udelukkende for at identificere kompatible enheder til bytte- eller videresalgsformål. Alle varemærker tilhører deres respektive ejere. Danghuan Europe er en uafhængig tjenesteudbyder og er ikke tilknyttet, godkendt af eller sponsoreret af disse mærker, medmindre det udtrykkeligt er angivet. Tilstedeværelsen af disse logoer indebærer ingen formel forretningsforbindelse.</p>
        <p>Brugen af tredjeparts varemærkelogoer er udelukkende til beskrivende formål. Alle sådanne mærker bevarer deres respektive rettigheder, og der antydes ingen tilknytning til Danghuan.</p>
      `
    },
    {
      title: "Opbevaring og datasikkerhed",
      content: `
        <p>Vi opbevarer dine data kun så længe, det er nødvendigt for at opfylde ovenstående formål eller som krævet ved lov. Vi anvender passende tekniske og organisatoriske foranstaltninger til at beskytte dine data, herunder kryptering, adgangskontrol og sikker opbevaring.</p>
      `
    },
    {
      title: "Dine rettigheder",
      content: `
        <p>Vi tilstræber at besvare alle gyldige dataanmodninger inden for én måned. For at beskytte dit privatliv kan vi have brug for at bekræfte din identitet, før vi behandler din anmodning.</p>
        <p>Du har ret til at:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Få adgang til og berigtige dine data</li>
          <li style='margin-bottom: 8px;'>Anmode om sletning ("retten til at blive glemt")</li>
          <li style='margin-bottom: 8px;'>Gøre indsigelse mod eller begrænse behandling</li>
          <li style='margin-bottom: 8px;'>Trække dit samtykke tilbage til enhver tid</li>
          <li style='margin-bottom: 8px;'>Anmode om dataportabilitet (hvor det er relevant)</li>
        </ul>
        <p>For at udøve disse rettigheder kan du kontakte os på <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></p>
      `
    },
    {
      title: "Opdateringer af politikken",
      content: `
        <p>Vi kan opdatere denne politik for at afspejle ændringer i lovkrav eller vores praksis for databehandling. Den seneste version vil altid være tilgængelig på vores hjemmeside.</p>
      `
    },
    {
      title: "Kontakt os",
      content: `
        <p>Hvis du har spørgsmål eller ønsker at udøve dine rettigheder, bedes du kontakte os:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'><strong>Danghuan Europe S.L.</strong></li>
          <li style='margin-bottom: 8px;'><strong>E-mail:</strong> <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></li>
          <li style='margin-bottom: 8px;'><strong>Hjemmeside:</strong> <a href="https://www.danghuan.eu" target="_blank">https://www.danghuan.eu</a></li>
        </ul>
        <p>Du kan også indgive en klage til din lokale databeskyttelsesmyndighed eller til Det Spanske Databeskyttelsesagentur (AEPD).</p>
      `
    },
    {
      title: "Tillæg – Udvidet juridisk og cookieinformation",
      subsections: [
        {
          title: "1. Retsgrundlag for databehandling",
          content: `
            <p>Det juridiske grundlag for behandling af dine personoplysninger omfatter:</p>
            <ul style='list-style-type: disc; padding-left: 20px;'>
              <li style='margin-bottom: 8px;'>Opfyldelse af en kontrakt (f.eks. behandling af bytteordrer, afsendelse af betalinger)</li>
              <li style='margin-bottom: 8px;'>Overholdelse af lovmæssige forpligtelser (f.eks. skatterapportering, identitetsverifikation)</li>
              <li style='margin-bottom: 8px;'>Dit samtykke (f.eks. markedsføringskommunikation eller tredjepartscookies)</li>
              <li style='margin-bottom: 8px;'>Legitime interesser (f.eks. forebyggelse af svig, intern analyse, forbedring af tjenester)</li>
            </ul>
          `
        },
        {
          title: "2. Foranstaltninger til forebyggelse af svig",
          content: `
            <p>Vi kan bruge dine personoplysninger (f.eks. enhedens serienummer, transaktionsmønster, IP-geolokation, IBAN-ejerskab) til at udføre svigdetektion ved hjælp af offentligt tilgængelige databaser og tjenester til bekæmpelse af svig. Dette gøres under vores legitime interesse i at forhindre identitetstyveri og misbrug af vores tjenester.</p>
            <p>Vi træffer ikke beslutninger udelukkende baseret på automatiseret behandling, der væsentligt påvirker dig.</p>
          `
        },
        {
          title: "3. Håndtering af data på eksterne markedspladser",
          content: `
            <p>Hvis du køber eller sælger enheder via tredjepartsplatforme som Amazon, Shopify, TEMU eller Back Market, kan Danghuan modtage dine ordreoplysninger, leveringsadresse og betalingsbekræftelse via en krypteret API eller et sikkert backoffice-system, udelukkende med det formål at gennemføre din transaktion og yde eftersalgsservice.</p>
          `
        },
        {
          title: "4. Cookiekategorier og detaljer",
          content: `
            <p>Du kan gennemgå den fulde liste over cookies, vi bruger — herunder navn, udbyder, formål, varighed og type (førsteparts eller tredjeparts) — i tabellen nedenfor. Dette omfatter analysecookies fra Google Analytics, retargeting-cookies fra Meta og betalingscookies fra PayPal.</p>
            <table style='border-collapse: collapse; width: 100%;'>
              <thead>
                <tr>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Kategori</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Cookienavn</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Udbyder</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Formål</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Varighed</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Type</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Strengt Nødvendig</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>OptanonConsent</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Lagrer cookiepræferencer</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 år</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Førstepart</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Strengt Nødvendig</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>session_id</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Opretholder sessionstilstand på tværs af sider</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Session</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Førstepart</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Funktionel</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>i18next</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Husker valgt sprogpræference</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Session</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Førstepart</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Funktionel</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>live_chat</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tawk.to</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Aktiverer live chat-support</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>6 måneder</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tredjepart</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Ydelse</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_ga</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Analytics</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Indsamler statistik over brug af hjemmesiden</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>2 år</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tredjepart</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Ydelse</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_gid</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Analytics</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Sporer brugeradfærd på tværs af sessioner</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>24 timer</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tredjepart</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Ydelse</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_clck</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Microsoft Clarity</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Opretholder brugeression på tværs af sider</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 år</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tredjepart</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Annoncering</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_fbp</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Meta (Facebook)</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Viser personlige annoncer baseret på adfærd</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>3 måneder</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tredjepart</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Annoncering</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_tt_enable_cookie</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>TikTok</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Sporer brugerinteraktioner og konverteringer</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>13 måneder</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tredjepart</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Annoncering</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_uetsid</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Bing</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Sporer brugere på tværs af hjemmesider til markedsføring</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 dag</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tredjepart</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Annoncering</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_gcl_au</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Ads</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Bruges til konverteringssporing</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>3 måneder</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tredjepart</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Annoncering</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>__kla_id</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Klaviyo</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Identificerer besøgende til e-mailmarketingkampagner</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>2 år</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tredjepart</td>
                </tr>
              </tbody>
            </table>
          `
        },
        {
          title: "5. Kampagner, reklamefremstød og undersøgelser",
          content: `
            <p>Når du deltager i vores kampagner, undersøgelser eller konkurrencer, kan vi indsamle dit navn, dine kontaktoplysninger og yderligere information, der er specifik for arrangementet (f.eks. alder, placering). Disse data bruges udelukkende til at administrere arrangementet, kontakte vindere og forbedre fremtidige kampagner.</p>
          `
        },
        {
          title: "6. Tilsynsmyndigheder",
          content: `
            <p>Du kan indgive en klage til følgende tilsynsmyndigheder, hvis du mener, at dine databeskyttelsesrettigheder er blevet krænket:</p>
            <ul style='list-style-type: disc; padding-left: 20px;'>
              <li style='margin-bottom: 8px;'>I Danmark: Datatilsynet (Det Danske Databeskyttelsestilsyn) – <a href="https://www.datatilsynet.dk" target="_blank">www.datatilsynet.dk</a></li>
              <li style='margin-bottom: 8px;'>I Den Europæiske Union: Du kan finde den relevante nationale tilsynsmyndighed for dit land på hjemmesiden for European Data Protection Board (EDPB) – <a href="https://edpb.europa.eu/about-edpb/board/members" target="_blank">https://edpb.europa.eu/about-edpb/board/members</a></li>
            </ul>
          `
        }
      ]
    }
  ]
};